import { QuantumDriveH, QuantumDriveC } from "Utilities/utils";
import {useLoader}                      from "components/Covers/loadingCover";
import {useInfoMsgModal}                from "components/Covers/infoMessageModal";

export async function Generic_Call(sys_body) 
{
    const   { hideLoader }      = useLoader();  
    let     server_response     = {};
    let     controller          = new AbortController();
    const   timeoutMs           = 29000; // 29 seconds
    let     timeoutId           = setTimeout(() => controller.abort(), timeoutMs);
    let     baseURL             = "";
    if (process.env.REACT_APP_STAGE === "prod") {
        baseURL                 = `https://wzl6hj9sl6.execute-api.us-east-1.amazonaws.com/latest/${sys_body.endpoint}`;
    }
    else {
        baseURL                 = `https://762z1qbh67.execute-api.us-east-1.amazonaws.com/latest/${sys_body.endpoint}`;
    }
    try {        
        server_response = await fetch(baseURL, {method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify(sys_body.content),
                                                signal: controller.signal
                                                });
        clearTimeout(timeoutId);

        if (!server_response.ok) {
            server_response = {};
            hideLoader();
            throw new Error(`HTTP error! Status: ${server_response.status}`);
        }
        return await server_response.json();
    } catch (error) {
        clearTimeout(timeoutId);
        hideLoader();
        console.error('Fetch error:', error);
        return await server_response;
    }
}

export async function GetSeferData(endpoint, content) 
{
    let currH            = localStorage.getItem("holocron");
    let currC            = localStorage.getItem("charlore");
    let payload          = {};
    let default_payload = {
        "endpoint": endpoint,
        "content": {
            "holocron": currH,
            "args": content
        }
    };
    // ->> Do something
    payload      = await Generic_Call(default_payload);
    if (payload) {
        if (payload?.status?.statusCode == 1939) {
            localStorage.clear();
            window.location.href = '/login';
        }
        else {
            if (currH != payload.response.holocron) {
                QuantumDriveH(payload.response.holocron);
            }
            if (currC != JSON.stringify(payload.response.charlore)){
                QuantumDriveC(payload.response.charlore);
            }
            return (payload);
        }
    }
}